import {Link as RouterLink, useLocation} from "react-router-dom";
import clsx from "clsx";

export default function Link({to, children = undefined, className = '', activeClass = 'text-gray-400', ...otherProps}) {
    const location = useLocation();
    const current = location.pathname === to;
    return <RouterLink {...otherProps} className={clsx(current && activeClass, className)} to={to}>
        {children}
    </RouterLink>
}